__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['axp-travel-search-date-picker'].baseUrl;
import ModuleContainer from './TravelSearchDatePickerWrapper';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    requiredExternals: {
      '@americanexpress/conditional-features': '^3.3.0',
      '@americanexpress/one-app-module-wrapper': '^3.5.0',
      '@americanexpress/travel-selectors': '^5.0.0',
      '@americanexpress/one-experiments': '^2.1.3',
      'react-intl': '^6.5.5'
    }
  });
}